module.exports = __webpack_public_path__ + "assets/a9079872c7780620b17fba33d3e4cc56.jpg";